import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiX } from 'react-icons/fi';
import ModalFooter from '../common/ModalFooter';

/* 
  DESIGN RULE: 
  Every modal primary action must use .rutabaga-button-primary via ModalFooter.
*/

const CreateProjectModal = ({ isOpen, onClose, onSubmit, loading, initialData = null }) => {
  const [formData, setFormData] = useState({ name: '', description: '', target_n: '' });

  useEffect(() => {
    if (initialData) {
      setFormData({ 
        name: initialData.name, 
        description: initialData.description || '',
        target_n: initialData.target_n || ''
      });
    } else {
      setFormData({ name: '', description: '', target_n: '' });
    }
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-rutabaga-dark/40 backdrop-blur-sm">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white w-full max-w-lg rounded-lg p-12 shadow-2xl relative border-t-4 border-rutabaga-pink"
      >
        <button onClick={onClose} className="absolute top-8 right-8 text-gray-400 hover:text-rutabaga-dark transition-colors p-1">
          <SafeIcon icon={FiX} className="text-xl" />
        </button>

        <h2 className="text-4xl font-black text-rutabaga-dark tracking-tight mb-2">
          {initialData ? 'Edit Project' : 'New Research Project'}
        </h2>
        <p className="text-gray-500 mb-8 font-medium">
          {initialData ? 'Update your study details.' : 'Define your study and start recruiting participants.'}
        </p>

        <form onSubmit={(e) => { e.preventDefault(); onSubmit(formData); }} className="space-y-6">
          <div>
            <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1.5 ml-1">Project Name</label>
            <input
              type="text"
              required
              autoFocus
              className="rutabaga-input"
              placeholder="e.g., Mobile App Navigation Study"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1.5 ml-1">Description (Optional)</label>
            <textarea
              className="rutabaga-input min-h-[100px] resize-none"
              placeholder="Describe the goals and scope of this research..."
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1.5 ml-1">Total interviews planned</label>
            <input
              type="number"
              required
              min="1"
              className="rutabaga-input"
              placeholder="eg 20"
              value={formData.target_n}
              onChange={(e) => setFormData({ ...formData, target_n: parseInt(e.target.value) || '' })}
            />
          </div>

          <ModalFooter 
            primaryLabel={initialData ? 'Save Changes' : 'Create Project'}
            onSecondary={onClose}
            secondaryLabel="Cancel"
            loading={loading}
            disabled={!formData.name || !formData.target_n}
          />
        </form>
      </motion.div>
    </div>
  );
};

export default CreateProjectModal;